import React from 'react';
import styled from 'styled-components';

import { createCollecticon } from '../collecticon-creator';

export const CollecticonTriangleUpSmall = styled(
  createCollecticon((props) => (
    <svg {...props}>
      <title>{props.title || 'triangle up small icon'}</title>
      <polygon points='8,5 13,10 3,10' />
    </svg>
  ))
)`
  /* icons must be styled-components */
`;
